import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { merge } from 'lodash';
import * as substanceActionTypes from './substanceActionTypes';

const byId = handleActions(
  {
    [substanceActionTypes.FETCH_SUBSTANCE_ACTIONS.SUCCESS]: (state, { payload }) =>
      merge({}, state, payload.entities.substanceActions),
  },
  {},
);

const allIds = handleActions(
  {
    [substanceActionTypes.FETCH_SUBSTANCE_ACTIONS.SUCCESS]: (state, { payload }) => [
      ...new Set([...state, ...payload.result]),
    ],
  },
  [],
);

export default combineReducers({
  byId,
  list: combineReducers({
    allIds,
  }),
});
